// Opções do select "Operação no portal" do credor (#313).
//
// A lista e os rótulos vêm do domínio (`MODOS_PORTAL` e `ROTULO_MODO_PORTAL`),
// que é a mesma lista do CHECK no banco. Aqui só se monta o formato do
// `SelectField`.

import { MODOS_PORTAL, ROTULO_MODO_PORTAL } from "@atlas/domain";
import type { ModoPortal } from "@atlas/sdk";

export const OPCOES_MODO_PORTAL: { value: ModoPortal; label: string }[] = MODOS_PORTAL.map((m) => ({
  value: m,
  label: ROTULO_MODO_PORTAL[m],
}));

/** Rótulo do modo para a lista; ausente é o default `credito`. */
export function rotuloModoPortal(modo: ModoPortal | null | undefined): string {
  return ROTULO_MODO_PORTAL[modo ?? "credito"];
}
